interface RouteParams {
    clientId: string;
    investmentHash: string;
    apartmentSymbol: string;
    targetWidth: number | null;
    wasAutoRefreshed: boolean;
}

class RouteService {
    routeParams!: RouteParams;

    constructor() {
        this.setRouteParams();
    }

    private setRouteParams() {
        const routeParams = window.location.pathname
            .split('/')
            .filter((routeParam) => routeParam);
        const search = window.location.search.split('?')[1];
        const stringObjectParams = search
            ? decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')
            : null;
        let queryParams;

        if (stringObjectParams) {
            queryParams = JSON.parse(`{"${stringObjectParams}"}`);
        }

        this.routeParams = {
            clientId: routeParams[0],
            investmentHash: routeParams[1],
            apartmentSymbol: queryParams?.number,
            targetWidth: Number(queryParams?.targetWidth) || null,
            wasAutoRefreshed: queryParams?.wasAutoRefreshed === 'true',
        };
    }

    public get clientId() {
        return this.routeParams.clientId;
    }

    public get investmentHash() {
        return this.routeParams.investmentHash;
    }

    public get apartmentSymbol() {
        return this.routeParams.apartmentSymbol;
    }

    public get targetWidth() {
        return this.routeParams.targetWidth;
    }
}

export default RouteService;
